module.exports = __webpack_public_path__ + "static/media/pero.1581bc02.png";